// components/MessageBoardFeedView.js
import React, { Component } from "react";
import axios from "axios";
import AnswerCard from "./AnswerCard"; // We'll create this

const config = require("../config.json"); // Adjust path if needed

export default class MessageBoardFeedView extends Component {
  state = {
    feedItems: [],
    loading: false,
    error: null,
    selectedLanguage: "da", // Default language, make sure it's lowercase
    supportedLanguages: [
      // Configure your supported languages
      { code: "da", name: "Danish" },
      { code: "en", name: "English" },
      // Add more languages as needed
    ],
    testCompanyId: "",
    lastEvaluatedKeys: null, // For pagination
    allLoaded: false, // To disable load more button
  };

  componentDidMount() {
    this.fetchFeed();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.selectedLanguage !== this.state.selectedLanguage ||
      prevState.testCompanyId !== this.state.testCompanyId
    ) {
      this.fetchFeed(true); // Reset feed if language or testCompanyId changes
    }
  }

  fetchFeed = async (reset = false) => {
    if (this.state.loading && !reset) return;

    this.setState({ loading: true, error: null });
    let currentLastKeys = this.state.lastEvaluatedKeys;
    if (reset) {
      this.setState({ feedItems: [], allLoaded: false });
      currentLastKeys = null; // Reset keys for a fresh fetch
    }

    const { selectedLanguage, testCompanyId } = this.state;
    const params = { languageCode: selectedLanguage.toLowerCase() };

    if (testCompanyId && testCompanyId.trim() !== "") {
      params.companyId = testCompanyId.trim();
    }
    if (!reset && currentLastKeys) {
      // Pass the composite key as a stringified, URI-encoded JSON
      params.lastEvaluatedKey = encodeURIComponent(
        JSON.stringify(currentLastKeys)
      );
    }

    try {
      const res = await axios.get(`${config.api.invokeUrl}/messageboard/feed`, {
        params,
      });
      // Expect res.data to be { items: [], lastEvaluatedKey: "stringified_composite_key_or_null" }
      const newItems = res.data.items || [];
      let newLastEvaluatedKeys = null;
      if (res.data.lastEvaluatedKey) {
        try {
          newLastEvaluatedKeys = JSON.parse(
            decodeURIComponent(res.data.lastEvaluatedKey)
          );
        } catch (e) {
          console.error(
            "Could not parse received composite lastEvaluatedKey",
            e
          );
          newLastEvaluatedKeys = null; // Treat as end of list on parse error
        }
      }

      this.setState((prevState) => ({
        feedItems: reset ? newItems : [...prevState.feedItems, ...newItems],
        lastEvaluatedKeys: newLastEvaluatedKeys, // Store the object
        allLoaded:
          !newLastEvaluatedKeys ||
          Object.keys(newLastEvaluatedKeys).length === 0,
        loading: false,
      }));
    } catch (err) {
      console.error("Error fetching feed:", err);
      this.setState({
        loading: false,
        error: `Failed to fetch feed: ${
          err.response?.data?.message || err.message
        }`,
      });
    }
  };

  handleLanguageChange = (event) => {
    this.setState({ selectedLanguage: event.target.value });
  };

  handleLoadMore = () => {
    if (!this.state.allLoaded && !this.state.loading) {
      this.fetchFeed();
    }
  };

  handleCompanyIdChange = (event) => {
    this.setState({ testCompanyId: event.target.value });
  };

  render() {
    const {
      feedItems,
      loading,
      error,
      selectedLanguage,
      supportedLanguages,
      allLoaded,
      testCompanyId,
    } = this.state;

    return (
      <div className="box">
        <h2 className="title is-4">Message Board Feed (Test View)</h2>

        <div className="field is-horizontal">
          <div className="field-label is-normal">
            <label className="label">Language:</label>
          </div>
          <div className="field-body">
            <div className="field">
              <div className="control">
                <div className="select">
                  <select
                    value={selectedLanguage}
                    onChange={this.handleLanguageChange}
                  >
                    {supportedLanguages.map((lang) => (
                      <option key={lang.code} value={lang.code}>
                        {lang.name} ({lang.code})
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div className="field is-horizontal">
          <div className="field-label is-normal">
            <label className="label" htmlFor="testCompanyIdInput">
              Test Company ID:
            </label>
          </div>
          <div className="field-body">
            <div className="field">
              <div className="control">
                <input
                  id="testCompanyIdInput"
                  className="input"
                  type="text"
                  placeholder="Leave blank for global feed"
                  value={testCompanyId}
                  onChange={this.handleCompanyIdChange}
                />
              </div>
            </div>
          </div>
        </div>
        <hr />

        {error && (
          <div className="notification is-danger is-light">{error}</div>
        )}

        {feedItems.length === 0 && !loading && !error && (
          <p>
            No items in the feed for the selected language, or all items have
            been loaded.
          </p>
        )}

        <div className="feed-container">
          {" "}
          {/* Optional: for styling */}
          {feedItems.map((item, index) => (
            // Assuming each item has a unique 'answerId'
            // The item should be an Answer object with questionTitle denormalized onto it
            <AnswerCard
              key={item.answerId || `answer-${index}`}
              answer={item}
            />
          ))}
        </div>

        {loading && (
          <p className="has-text-centered mt-4">Loading feed items...</p>
        )}

        {!loading && !allLoaded && feedItems.length > 0 && (
          <div className="has-text-centered mt-5">
            <button onClick={this.handleLoadMore} className="button is-info">
              Load More Answers
            </button>
          </div>
        )}
        {allLoaded && feedItems.length > 0 && (
          <p className="has-text-centered has-text-grey mt-4">
            All answers loaded.
          </p>
        )}
      </div>
    );
  }
}
